import { FunctionComponent } from "react";
import { Box, Button } from "@mui/material";
import { colorGrayLight } from "../../styles/theme";
import RelevancyScore from "./RelevancyScore";
import BasketIcon from "../Icons/Basket";
import RelevancyToggle, { RelevancyValue } from "./RelevancyToggle";

interface CardItemProps {
	score: number;
	isInBasket: boolean;
	onAddToBasket: () => void;
	selectedRelevancy?: RelevancyValue | null;
	onRelevancyChange?: (value: RelevancyValue) => void;
}

const CardHead: FunctionComponent<CardItemProps> = ({
	score,
	isInBasket,
	onAddToBasket,
	selectedRelevancy,
	onRelevancyChange,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				height: "42px",
				marginBottom: "4px",
			}}
		>
			<Box>
				<Box sx={{ position: "absolute", top: "-18px" }}>
					<RelevancyScore score={score} />
				</Box>
			</Box>
			<Box
				sx={{
					display: "flex",
					gap: "15px",
					alignItems: "center",
				}}
			>
				{onRelevancyChange && (
					<RelevancyToggle
						variant="compact"
						selectedValue={selectedRelevancy ?? null}
						onChange={onRelevancyChange}
					/>
				)}
				<Button
					variant="outlined"
					onClick={onAddToBasket}
					sx={{
						borderRadius: "10px",
						width: "50px",
						height: "40px",
						backgroundColor: isInBasket ? colorGrayLight : "transparent",
						"&:hover": {
							backgroundColor: isInBasket ? colorGrayLight : undefined,
						},
					}}
				>
					<BasketIcon sx={{ width: 20, height: 19, cursor: "pointer" }} />
				</Button>
			</Box>
		</Box>
	);
};

export default CardHead;
